import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  GET_MALWARE_DETECTIONS_ASYNC,
  RESET_MALWARE_DETECTION_ERROR,
  UPDATE_MALWARE_DETECTION_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
    detectionItemLoader: false,
    detectionItemError: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case GET_MALWARE_DETECTIONS_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case GET_MALWARE_DETECTIONS_ASYNC.SUCCESS:
        return {
          ...state,
          loader: false,
          data: {
            ...state.data,
            [action.payload.name]: action.payload.data,
          },
        }
      case GET_MALWARE_DETECTIONS_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case GET_MALWARE_DETECTIONS_ASYNC.CANCEL:
        return { ...state, loader: false }
      case UPDATE_MALWARE_DETECTION_ASYNC.INITIATE:
        return { ...state, error: null, detectionItemLoader: true }
      case UPDATE_MALWARE_DETECTION_ASYNC.SUCCESS:
      case UPDATE_MALWARE_DETECTION_ASYNC.CANCEL:
        return { ...state, detectionItemLoader: false }
      case UPDATE_MALWARE_DETECTION_ASYNC.ERROR:
        return {
          ...state,
          detectionItemLoader: false,
          detectionItemError: action.error,
        }
      case RESET_MALWARE_DETECTION_ERROR:
        return {
          ...state,
          detectionItemLoader: false,
          detectionItemError: null,
        }
      default:
        return state
    }
  }
}
